import React, { useEffect, useState } from 'react'
import { api } from '../../shared/ApiProvider'

const SelectField = ({
                       url,
                       setClass,
                       formKey,
                       className,
                       formData,
                       handleSelect,
                     }) => {
  const [options, setOptions] = useState(null)
  useEffect(() => {
    console.log('running select fetch')
    api.get(url).then((response) => {
      const { data } = response
      const optionsData = data.map(entry => {
        return {
          code: entry.OrgID,
          name: entry.Name,
        }
      })
      console.log(optionsData)
      setOptions(optionsData)
    })
  }, [url])

  return (
    <>
      {options && formData ? (
        <select
          className={`form-control col pl-0 ${setClass(formKey)}`}
          id={formKey}
          onChange={handleSelect}
          value={
            formData[formKey] !== undefined &&
            formData[formKey] !== null &&
            formData[formKey] !== ''
              ? `${formData[formKey]}`
              : ' '
          }
        >
          {options.map((option, index) => {
            return (
              <option
                key={`${formKey}-${option.code}-${index}`}
                value={`${option.code}`}
              >
                {option.code} {option.name}
              </option>
            )
          })}
          <option key={`${formKey}-none`} value={' '}>
            None
          </option>
        </select>
      ) : (
        <select
          className={`form-control col pl-0 ${className}`}
          id={formKey}
          onChange={handleSelect}
        >
          <option key={`${formKey}-loading`}>{'Loading...'}</option>
        </select>
      )}
    </>
  )
}
export default SelectField